import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { productKeys } from './keys';

import type { TypeGetSalesChannelCodesResponse } from '~/types/product.types';

const ENDPOINT = '/api-lip/v1/third-parties/sales-channel/codes';

/**
 * [상품관리][상품 판매처 매핑] 판매처 코드 목록 조회 API
 */
export const fetchSalesChannelCodes = async (): Promise<TypeGetSalesChannelCodesResponse> => {
  const { data } = await axiosInstance.get<TypeGetSalesChannelCodesResponse>(ENDPOINT);
  return data;
};

/**
 * [상품관리][상품 판매처 매핑] 판매처 코드 목록 조회 Query Hook
 */
export const useGetSalesChannelCodesQuery = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: productKeys.salesChannelCodes(),
    queryFn: fetchSalesChannelCodes,
    staleTime: 1000 * 60 * 30,
    enabled: options?.enabled ?? true,
  });
};
